import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, xs },
} = constants.breakpoints;
const circular = typographyStyles.fontFamily.circular;
const { heading3Obj } = typographyStyles;

const greyDark = constants.colors.ui.neutral[600];

export const containerCss = {
  padding: "16px",

  [mediaQuery.downTo(xs)]: {
    padding: "40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "24px",
  },
};

export const titleCss = {
  ...heading3Obj,
  ...circular,
  color: greyDark,
  margin: 0,
};
